var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, InputAdornment, useMediaQuery } from "@material-ui/core";
import { createFilterOptions, useAutocomplete, } from "@material-ui/lab";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FTLChip, FTLDots, FTLTextField, ClearIcon, FTLCheckbox, FTLDivider, FTLIconButton, SearchIcon, } from "../../../..";
import FTLSelectStyles from "../styles/FTLSelectStyles.styles";
import { axiosNormalizeResponse, initialAsyncState, } from "../model/FTLSelectModel";
import FTLSelectControl from "./FTLSelectControl";
import FTLDropdownMenu from "../../../dropdowns/FTLDropdownMenu";
import FTLInfiniteLoader from "./FTLInfiniteLoader";
import { useDebounceValue } from "../../../..";
export default (_a) => {
    var _b;
    var { onChange, onInputChange, getOptionDetail = (option) => { var _a; return (_a = option === null || option === void 0 ? void 0 : option.detail) !== null && _a !== void 0 ? _a : null; }, getLimitTagsText, getNoOptionsWithFilterText = (query) => `По запросу "${query}" ничего не найдено `, getItemKey = (option) => option.value, getCreatedOptionLabel = (option) => `Добавить "${option.label}"`, getOptionLabel = (option) => { var _a; return (_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : ""; }, getOptionSelected = (option, value) => (option === null || option === void 0 ? void 0 : option.value) === (value === null || value === void 0 ? void 0 : value.value), filterOptions, limitTags = Infinity, noOptionsText = "Нет данных", loadingText = React.createElement(FTLDots, { color: "tertiary" }), loading, placeholder, label, asyncData, searchable = Boolean(asyncData), searchInList = Boolean(asyncData), searchPlaceholder = "Поиск", showCheckboxes = false, options = [], DropdownMenuProps, inputValue, multiple, disabled, disableCloseOnSelect, clearText = "Очистить", openText = "Открыть", closeText = "Закрыть", open, menuWidth, records = 10, itemSize = 32, error = false, disableClearable, required, hideLoader, popperPlacement = "bottom-start", creatable, BoxProps, asyncDataDependencies = [], value: valueFromProps = multiple ? [] : null, debounceDelay = 500 } = _a, otherProps = __rest(_a, ["onChange", "onInputChange", "getOptionDetail", "getLimitTagsText", "getNoOptionsWithFilterText", "getItemKey", "getCreatedOptionLabel", "getOptionLabel", "getOptionSelected", "filterOptions", "limitTags", "noOptionsText", "loadingText", "loading", "placeholder", "label", "asyncData", "searchable", "searchInList", "searchPlaceholder", "showCheckboxes", "options", "DropdownMenuProps", "inputValue", "multiple", "disabled", "disableCloseOnSelect", "clearText", "openText", "closeText", "open", "menuWidth", "records", "itemSize", "error", "disableClearable", "required", "hideLoader", "popperPlacement", "creatable", "BoxProps", "asyncDataDependencies", "value", "debounceDelay"]);
    const [asyncState, setAsyncState] = useState(initialAsyncState);
    const [query, setQuery] = useState("");
    const [inputVal, setInputValue] = useState("");
    const [popupOpen, setPopupOpen] = useState(open || false);
    const anchorRef = useRef(null);
    const [prevValue, setPrevValue] = useState(null);
    const popupRef = useRef(null);
    const [listEl, setListEl] = useState(null);
    const mobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const requestTriggerRef = useRef(false);
    const debouncedQuery = useDebounceValue(query, debounceDelay);
    const searchQuery = (searchable && searchInList) || multiple || mobile
        ? debouncedQuery
        : inputVal;
    const onInputChangeCb = useCallback((e, value, reason) => {
        if (reason === "reset" || multiple || (searchInList && searchable)) {
            setInputValue(value);
            onInputChange && onInputChange(e, value, reason);
            setPrevValue(value);
        }
        else {
            const newValue = prevValue ? value.replace(prevValue, "") : value;
            setInputValue(newValue);
            onInputChange && onInputChange(e, newValue, reason);
            setPrevValue(null);
        }
    }, [onInputChange]);
    const onChangeCb = (e, value, reason, details) => {
        var _a;
        e.stopPropagation();
        if (onChange) {
            if (disableCloseOnSelect || !multiple) {
                if (!listEl)
                    (_a = inputProps.ref.current) === null || _a === void 0 ? void 0 : _a.blur();
                else
                    listEl.blur();
            }
            onChange(value, reason, details, e);
        }
    };
    const loadItemsCb = useCallback((request, asyncData) => __awaiter(void 0, void 0, void 0, function* () {
        const { loadItems, normalizeResponse } = asyncData;
        try {
            setAsyncState((state) => (Object.assign(Object.assign({}, state), { loading: request.offset === 0 })));
            const response = yield loadItems(request);
            const { items, count } = normalizeResponse
                ? normalizeResponse(response)
                : axiosNormalizeResponse(response);
            const normalizeScheme = asyncData.normalizeScheme;
            const normalizedItems = items.map((item) => {
                const obj = {};
                Object.keys(normalizeScheme).forEach((key) => {
                    const value = normalizeScheme[key];
                    if (value instanceof Function)
                        obj[key] = value(item);
                    else if (value in item)
                        obj[key] = item[value];
                    else
                        obj[key] = "";
                });
                return obj;
            });
            if (request.offset > 0) {
                asyncState.items.splice(request.offset, 0, ...normalizedItems);
                setAsyncState({
                    items: asyncState.items,
                    count,
                    offset: request.offset + normalizedItems.length,
                    loading: false,
                });
                return { items, count };
            }
            else {
                setAsyncState({
                    items: normalizedItems,
                    count,
                    offset: normalizedItems.length,
                    loading: false,
                });
                return { items, count };
            }
        }
        catch (e) {
            setAsyncState((state) => (Object.assign(Object.assign({}, state), { loading: false })));
            return { items: [], count: 0 };
        }
    }), [asyncState, , setAsyncState, asyncData, ...asyncDataDependencies]);
    const { getRootProps, getInputLabelProps, getInputProps, getListboxProps, getOptionProps, getTagProps, getClearProps, getPopupIndicatorProps, value, groupedOptions, } = useAutocomplete(Object.assign({ options: asyncData ? asyncState.items : options, getOptionLabel,
        getOptionSelected, onChange: onChangeCb, multiple, open: true, inputValue: searchQuery, filterOptions: asyncData
            ? (options) => options
            : creatable
                ? (options, params) => {
                    const filter = createFilterOptions();
                    const filtered = filter(options, params);
                    if (params.inputValue !== "") {
                        filtered.push({
                            value: params.inputValue,
                            label: params.inputValue,
                            created: true,
                        });
                    }
                    return filtered;
                }
                : filterOptions, onInputChange: onInputChangeCb, value: valueFromProps }, otherProps));
    const inputProps = getInputProps();
    useEffect(() => {
        const inputValue = 
        //@ts-ignore
        Array.isArray(value) || value === null || undefined || ""
            ? ""
            : getOptionLabel(value);
        setInputValue(inputValue);
        setPrevValue(inputValue);
        setQuery("");
    }, [value]);
    const classes = FTLSelectStyles({
        showCheckboxes,
        searchInList: searchInList || multiple,
    });
    const isMultiAndHasValue = Boolean(multiple && Array.isArray(value) && value.length);
    const hasValue = isMultiAndHasValue ||
        Boolean((value !== null || undefined || "") && !Array.isArray(value));
    // || Boolean(searchQuery)
    const startAdornment = useMemo(() => {
        let result = null;
        if (Array.isArray(value) && isMultiAndHasValue) {
            result = [];
            for (let i = 0; i < value.length && (i <= limitTags || popupOpen); i++)
                if (i < limitTags || popupOpen) {
                    result.push(React.createElement(FTLChip, Object.assign({}, getTagProps({ index: i }), { label: getOptionLabel(value[i]) })));
                }
                else {
                    const more = value.length - limitTags;
                    result.push(getLimitTagsText ? getLimitTagsText(more) : `+${more}`);
                }
        }
        return result;
    }, [value, popupOpen]);
    useEffect(() => {
        if (listEl && popupOpen)
            listEl.focus();
    }, [listEl, popupOpen]);
    useEffect(() => {
        if (open !== undefined && open !== popupOpen)
            setPopupOpen(open);
    }, [open, popupOpen]);
    useEffect(() => {
        if (asyncData) {
            setAsyncState(initialAsyncState);
            if (requestTriggerRef.current)
                loadItemsCb({
                    offset: 0,
                    limit: records,
                    query: searchQuery,
                }, asyncData);
        }
    }, [
        searchQuery,
        (_b = asyncData === null || asyncData === void 0 ? void 0 : asyncData.reloadDeps) === null || _b === void 0 ? void 0 : _b.toString(),
        requestTriggerRef.current,
        ...asyncDataDependencies,
    ]);
    useEffect(() => {
        var _a;
        if (disabled) {
            setPopupOpen(false);
            if (listEl)
                listEl.blur();
            else
                (_a = inputProps.ref.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    }, [disabled]);
    return (React.createElement(Box, Object.assign({}, getRootProps(), { width: "100%" }, BoxProps),
        React.createElement(FTLSelectControl, Object.assign({ required: required, hasValue: hasValue, hideInput: isMultiAndHasValue, hideLoader: hideLoader, popupOpen: popupOpen, clearProps: getClearProps(), popupIndicatorProps: getPopupIndicatorProps(), InputLabelProps: getInputLabelProps(), onChange: (e) => onInputChangeCb(e, e.target.value, "input"), placeholder: placeholder, ref: anchorRef, label: label, error: error, readOnly: !searchable || searchInList || multiple || mobile, disabled: disabled, clearable: !disableClearable, closeText: closeText, clearText: clearText, openText: openText, loading: asyncData ? asyncState.loading : loading, onPopupIndicatorClick: (e) => {
                var _a;
                if (popupOpen) {
                    e.stopPropagation();
                    setPopupOpen(false);
                    (_a = inputProps.ref.current) === null || _a === void 0 ? void 0 : _a.blur();
                    listEl === null || listEl === void 0 ? void 0 : listEl.blur();
                }
            }, onClick: mobile && !disabled
                ? (e) => {
                    e.preventDefault();
                    requestTriggerRef.current = true;
                    setPopupOpen(true);
                    if (listEl)
                        listEl.focus();
                }
                : undefined, inputProps: Object.assign(Object.assign({}, inputProps), { value: inputVal || "", onFocus: !mobile
                    ? (e) => {
                        e.preventDefault();
                        requestTriggerRef.current = true;
                        setPopupOpen(true);
                        if (listEl)
                            listEl.focus();
                    }
                    : undefined, onBlur: !mobile
                    ? (e) => {
                        e.preventDefault();
                        if (!listEl) {
                            setPopupOpen(false);
                        }
                    }
                    : undefined }) }, otherProps), startAdornment),
        React.createElement(FTLDropdownMenu, Object.assign({ open: popupOpen, onClose: () => {
                setPopupOpen(false);
            }, anchorEl: anchorRef.current, ref: popupRef, menuWidth: menuWidth, placement: popperPlacement }, DropdownMenuProps, getListboxProps()),
            (searchInList || multiple || mobile) && searchable && (React.createElement(React.Fragment, null,
                React.createElement(FTLTextField, { variant: "standard", autoCorrect: "off", autoComplete: "off", fullWidth: true, focused: true, spellCheck: "false", className: classes.listSearch, onBlur: () => {
                        setPopupOpen(false);
                    }, size: "small", InputProps: {
                        endAdornment: (React.createElement(InputAdornment, { position: "end" }, query ? (React.createElement(FTLIconButton, { size: "small", onClick: () => {
                                setQuery("");
                            } },
                            React.createElement(ClearIcon, null))) : (React.createElement(FTLIconButton, { size: "small" },
                            React.createElement(SearchIcon, null))))),
                    }, inputRef: setListEl, value: query, onChange: (e) => {
                        setQuery(e.target.value);
                    }, placeholder: searchPlaceholder }),
                React.createElement(FTLDivider, null))),
            React.createElement("div", { className: classes.listWrapper }, groupedOptions.length > 0 || (asyncData && asyncState.loading) ? (React.createElement(FTLInfiniteLoader, { itemCount: asyncData ? undefined : groupedOptions.length, asyncData: asyncData && Object.assign(Object.assign({}, asyncData), { loadItems: (request) => loadItemsCb(request, asyncData), state: asyncState, setState: setAsyncState, query: searchQuery, loadingText: (React.createElement("div", { className: classes.noDataWrapper }, loadingText)) }), getItemKey: getItemKey, itemSize: itemSize, records: records, width: menuWidth }, ({ index, style }) => {
                const option = groupedOptions[index];
                if (option) {
                    const optionProps = getOptionProps({
                        option,
                        index,
                    });
                    const label = option.created
                        ? getCreatedOptionLabel(option)
                        : getOptionLabel(option);
                    const detail = getOptionDetail && getOptionDetail(option);
                    return (React.createElement("div", Object.assign({}, optionProps, { className: classes.option, style: style, "aria-label": label }),
                        showCheckboxes ? (React.createElement("div", { className: classes.checkboxWrapper },
                            React.createElement(FTLCheckbox, { size: "small", checked: optionProps["aria-selected"] }),
                            label)) : (React.createElement("div", { className: classes.optionText }, label)),
                        detail && React.createElement("div", { className: classes.detail }, detail)));
                }
                return (React.createElement("div", { className: classes.option, style: style },
                    React.createElement("div", { className: classes.optionText }, loadingText)));
            })) : (React.createElement("div", { className: classes.noDataWrapper, "aria-label": "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445" }, searchQuery
                ? getNoOptionsWithFilterText(searchQuery)
                : noOptionsText))))));
};
//# sourceMappingURL=FTLSelect.js.map